import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import rem from 'polished/lib/helpers/rem';

import isEmpty from 'lodash/isEmpty';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Link from '@decisiv/ui-components/lib/components/Link';
import Tooltip from '@decisiv/ui-components/lib/components/Tooltip';

import ExternalLink from '@decisiv/iconix/lib/components/ExternalLink';

import DisabledLink from './DisabledLink';
import { IconContainer } from './styles';

export default function LinkToCase({
  text,
  tooltipText,
  to,
  icon: Icon = ExternalLink,
  iconPosition,
  iconOnly,
  showIcon,
  ...rest
}) {
  const ref = useRef();

  if (!text && !iconOnly) {
    return null;
  }

  if (to) {
    return (
      <Tooltip
        enabled={!isEmpty(tooltipText)}
        target={
          <Link
            icon={showIcon ? Icon : undefined}
            iconPosition={iconPosition}
            target="_blank"
            text={iconOnly ? undefined : text}
            aria-label={text}
            to={to}
            {...rest}
          />
        }
      >
        {tooltipText}
      </Tooltip>
    );
  }

  return (
    <>
      <DisabledLink
        as="span"
        css={`
          overflow-wrap: break-word;
          word-break: break-word;
          hyphens: auto;
          white-space: pre-wrap;
          flex-direction: ${
            /* istanbul ignore next -- @preserve */
            iconPosition === 'right' ? undefined : 'row-reverse'
          };
          svg {
            margin-${
              /* istanbul ignore next -- @preserve */
              iconPosition === 'right' ? 'left' : 'right'
            }: ${rem(spacing.base / 2)};
          }
        `}
        ref={ref}
        {...rest}
      >
        {iconOnly ? '' : text}
        {showIcon && (
          <IconContainer>
            <Icon {...rest} />
          </IconContainer>
        )}
      </DisabledLink>
      <Tooltip target={ref} zIndex={10}>
        {t`You do not have permission to access this link.`}
      </Tooltip>
    </>
  );
}

LinkToCase.propTypes = {
  iconPosition: PropTypes.oneOf(['left', 'right']),
  text: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  to: PropTypes.string,
  iconOnly: PropTypes.bool,
  showIcon: PropTypes.bool,
  icon: PropTypes.node,
};

LinkToCase.defaultProps = {
  iconPosition: 'right',
  text: '',
  to: null,
  iconOnly: false,
  showIcon: true,
  icon: undefined,
  tooltipText: undefined,
};
